import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import { getTokenHeader } from "@/helpers/commonHelper";
import { loadConfig } from "@/helpers/layoutWizardHelper";
import "./LayoutWizard.scss";

export default {
  name: "LayoutWizard",
  components: {},
  data() {
    return {
      spData: {},
      adData: {},
      lastActivities: [],
      statistic: {},
      config: {}
    };
  },
  async mounted() {
    try {
      await this.loadStatistics();
      await this.loadConfig();
      await this.$store.dispatch("getAllUsers");
    } catch (error) {
      await this.$store.dispatch("createError", error);
    }
  },
  computed: {
    user() {
      return this.$store.state.currentUser;
    },
    users() {
      return this.$store.state.users ?? [];
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    }
  },
  methods: {
    loadConfig,
    async loadStatistics() {
      let statistic = await this.getStatisticData();
      this.statistic = statistic;

      this.lastActivities = statistic.last_activities;
    },
    goTo(path) {
      this.$router.push(path);
    },
    getUserAvatar(updatedBy) {
      let user = this.users?.find(user => user._id === updatedBy);
      if (!user && this.user?._id === updatedBy) {
        user = this.user;
      }
      return user?.avatar_uri || "";
    },
    async getStatisticData() {
      const headers = getTokenHeader();
      const params = {
        principal_id: this.currentPrincipal
      };
      try {
        const result = await axios.get(
          `${env.assistent_api_client_url}statistics`,
          {
            params,
            headers
          }
        );
        return result.data;
      } catch (err) {
        this.$emit("createError", err);
      }
    }
  }
};
